// For Repository UserAssociation
import type { AsyncData } from '#app';
import type { IModelResponse } from '~/services/base/dto/base.dto';
import type { IModelGETUserAssociationConversationRequest, IModelGETUserAssociationConversationResponse } from './dto/user-asso.dto';

export class UserAssociationRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService
  }

  async getUserAssociationConversation(params: IModelGETUserAssociationConversationRequest): Promise<AsyncData<IModelResponse<IModelGETUserAssociationConversationResponse[]>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/user-association/conversation`, this.configService, {
      params,
    });
    return dataResult;
  }
}